module.exports = __webpack_public_path__ + "img/read.20a804da.png";